import { render } from "./Risk_Classifications.vue?vue&type=template&id=a52680bc"
import script from "./Risk_Classifications.vue?vue&type=script&lang=js"
export * from "./Risk_Classifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__